module.exports = __webpack_public_path__ + "media/images/single10-89beb615cda4bfdaff969555008fed95.jpg";